import { render, staticRenderFns } from "./OrderError.vue?vue&type=template&id=202953b6&scoped=true"
import script from "./OrderError.vue?vue&type=script&lang=js"
export * from "./OrderError.vue?vue&type=script&lang=js"
import style0 from "./OrderError.vue?vue&type=style&index=0&id=202953b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202953b6",
  null
  
)

export default component.exports